import { distanceInWordsStrict } from 'date-fns'

const MS_PER_WEEK = 1000 * 60 * 60 * 24 * 7
const MS_PER_DAY = 1000 * 60 * 60 * 24
const MS_PER_HOUR = 1000 * 60 * 60
const MS_PER_MINUTE = 1000 * 60
const MS_PER_SECOND = 1000

const offset = new Date().getTimezoneOffset()

export function localize(date) {
  date.setMinutes(date.getMinutes() - offset)
  return date
}

export function subtract(date, value, quantity) {
  switch (value) {
    case 'hour':
      return date - MS_PER_HOUR * quantity
    case 'day':
      return date - MS_PER_DAY * quantity
    case 'week':
      return date - MS_PER_WEEK * quantity
    case 'month':
      const newDate = new Date(date)
      newDate.setMonth(newDate.getMonth() - quantity)
      return newDate.getTime()
  }

  return date
}

// a and b are javascript Date objects
export function dateDiff(a, b, period) {
  if (!a || !b) return
  // Discard the time and time-zone information.
  var utc1 = a.getTime()
  var utc2 = b.getTime()
  let ms
  switch (period) {
    case 'seconds':
      ms = MS_PER_SECOND
      break
    case 'minutes':
      ms = MS_PER_MINUTE
      break
    case 'hours':
      ms = MS_PER_HOUR
      break
    case 'days':
      ms = MS_PER_DAY
      break
    default:
      ms = MS_PER_WEEK
      break
  }

  return Math.floor((utc1 - utc2) / ms)
}

export function timeTo(time) {
  let text = distanceInWordsStrict(new Date(), new Date(parseInt(time)))
  text = text.replace(' ', '')
  const digits = parseInt(text).toString().length
  if (text.includes('month')) {
    return text.slice(0, digits + 2)
  } else {
    return text.slice(0, digits + 1)
  }
}

export function getPlayerTime(milliseconds = 0) {
  let seconds = (milliseconds / 1000).toFixed(0)
  let minutes = Math.floor(seconds / 60)
  let hours = ''
  if (minutes > 59) {
    hours = Math.floor(minutes / 60)
    hours = hours >= 10 ? hours : '0' + hours
    minutes = minutes - hours * 60
    minutes = minutes >= 10 ? minutes : '0' + minutes
  }

  seconds = Math.floor(seconds % 60)
  seconds = seconds >= 10 ? seconds : '0' + seconds
  if (hours !== '') {
    return hours + ':' + minutes + ':' + seconds
  }
  return minutes + ':' + seconds
}

export function getDateString(time) {
  if (!time) {
    return null
  }
  const d = new Date(time * 1000)
  return d.getFullYear() + ' ' + d.toDateString().split(' ')[1] + ' ' + d.getDate()
}

export function getShortDateString(time) {
  if (!time) {
    return null
  }
  const d = new Date(time * 1000)
  const c = new Date()
  const fullYear = d.getFullYear()
  return d.toDateString().split(' ')[1] + ' ' + d.getDate() + (fullYear !== c.getFullYear() ? ', ' + fullYear : '')
}

export function timeSince(date) {
  const seconds = Math.floor((new Date() - date * 1000) / 1000)
  let interval = Math.floor(seconds / 604800)
  if (interval > 1) {
    return interval + 'w'
  }
  interval = Math.floor(seconds / 86400)
  if (interval > 1) {
    return interval + 'd'
  }
  interval = Math.floor(seconds / 3600)
  if (interval > 1) {
    return interval + 'h'
  }
  interval = Math.floor(seconds / 60)
  if (interval > 1) {
    return interval + ' m'
  }
  return Math.floor(seconds) + 's'
}

const getDayStart = date => Math.floor(date.setHours(0, 0, 0, 0) / 1000)
const getDayEnd = date => Math.floor(date.setHours(23, 59, 59, 999) / 1000)

const getMonday = () => {
  const now = new Date()
  const day = now.getDay() || 1
  if (day !== 1) now.setHours(-24 * (day - 1))
  return now
}
const getSunday = () => {
  const now = new Date()
  const day = now.getDay() || 7
  if (day !== 7) now.setHours(24 * (7 - day))
  return now
}

const getMonthsFirstDay = date => new Date(date.getFullYear(), date.getMonth(), 1)
const getMonthsLastDay = date => new Date(date.getFullYear(), date.getMonth() + 1, 0)

export const getTimeInterval = timeRange => {
  const now = new Date()
  if (timeRange === 'today') {
    return {
      from_date: getDayStart(now),
      to_date: getDayEnd(now)
    }
  }
  if (timeRange === 'week') {
    return {
      from_date: getDayEnd(getMonday()),
      to_date: getDayEnd(getSunday())
    }
  }
  if (timeRange === 'month') {
    return {
      from_date: getDayStart(getMonthsFirstDay(now)),
      to_date: getDayEnd(getMonthsLastDay(now))
    }
  }
}

export const getShortMonth = date => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthNames[date.getMonth()]
}

export const getDay = date => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  return days[date.getDay()]
}

export const getDateTimeStamp = date => {
  return (
    date.getUTCFullYear() +
    '/' +
    (date.getUTCMonth() + 1) +
    '/' +
    date.getUTCDate() +
    ' ' +
    date.getUTCHours() +
    ':' +
    date.getUTCMinutes() +
    ':' +
    date.getUTCSeconds()
  )
}
